import { render, staticRenderFns } from "./thirdCaseRow.vue?vue&type=template&id=125937e4&"
import script from "./thirdCaseRow.vue?vue&type=script&lang=js&"
export * from "./thirdCaseRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports